import subsystemUrls from "./subsystemUrls"
export { subsystemUrls }
export const timeout = 10000; // Request timeout in milliseconds
export const CONFIG_API_BASE_URL = process.env.VUE_APP_API_BASE_URL
export const CONFIG_SSO_SERVER_ENDPOINT = process.env.VUE_APP_SSO_SERVER_ENDPOINT
export const CONFIG_GRAPHQL_URL = process.env.VUE_APP_API_BASE_URL + "/graphql"
// export const CONFIG_WARNING_THRESHOLD = process.env.VUE_APP_WARNING_THRESHOLD
// export const CONFIG_THROTTLE_DELAY = process.env.VUE_APP_THROTTLE_DELAY
// export const CONFIG_SSO_SERVER_URL = process.env.VUE_APP_SSO_SERVER_URL
export const CONFIG_INACTIVITY_TIMEOUT_IN_SECOND = process.env.VUE_APP_INACTIVITY_TIMEOUT_IN_SECOND
export const CONFIG_WARNING_DURATION_IN_SECOND = process.env.VUE_APP_WARNING_DURATION_IN_SECOND
export const availableSubSystems = ["clarity", "onyx", "onyxArchive"]
export const healthcheckFrequency = process.env.VUE_APP_HEALTHCHECK_FREQUENCY || 60000 // 1 minute
// export const CONFIG_STORE_CACHE_IN_MS = process.env.VUE_APP_CONFIG_STORE_CACHE_IN_MS || 5 * 60 * 1000 // default to 5 minutes
export const CONFIG_SSO_SERVER_CALLBACK = `/login${process.env.VUE_APP_SSO_SERVER_ENDPOINT}` 
export const IS_PRODUCTION = process.env.VUE_APP_ENV || "development"